import React from "react";
import { useMode } from "../../context/useMode";

const QuestionContainer = ({
  question,
  selectedAnswer,
  onAnswer,
  className,
}) => {
  const { mode } = useMode();
  return (
    <div className={` h-full ${className}`}>
      <div
        className={`border-div ${mode === "light" ? "bg-white85 text-black" : "bg-black85 text-white"
          }  max-w-[786px] mx-auto  rounded-[10px] p-3 h-full flex flex-col justify-around`}
      >
        <p className="text-18">{`${question?.text}`}</p>

        <div className="radio-buttons flex h-[80px] mt-4">
          {question.answers.map((option, index) => (
            <label
              key={index}
              className={` ${mode} radio-label flex-1 flex-shrink-0 flex flex-col items-center text-center "`}
            >
              <input
                type="radio"
                name={`question-${question?.id}`}
                value={option.value}
                checked={selectedAnswer === option.value}
                onChange={() => onAnswer(option.value)}
                className={`radio-input border-2 ${mode === "dark" ? "" : "border-black"} ${mode}`}
              />
              {selectedAnswer === "" && (
                <span className="mt-1 text-12">
                  {(index == 0 || index == 3 || index == 6) && option.text}
                </span>
              )}
              {selectedAnswer === option.value && (
                <span
                  className={` mt-1 font-bold text-12 ${mode === "dark" ? "bg-dark-soul bg-clip-text text-transparent" : "bg-light-soul bg-clip-text text-transparent"
                    }`}
                >
                  {option.text}
                </span>
              )}
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuestionContainer;
